/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { getOr } from 'lodash/fp';

const name = 'alert';

const { actions, reducer } = {
  ...createSlice({
    name,
    initialState: {
      open: false,
      severity: 'info',
      message: '',
      persistent: false,
    },
    reducers: {
      open: (state, { payload }) => ({
        open: true,
        severity: payload.severity,
        message: payload.message,
        persistent: Boolean(payload.persistent),
      }),
      close: (state) => ({
        ...state,
        open: false,
      }),
      clear: (state) => ({
        ...state,
        severity: 'info',
        message: '',
        persistent: false,
      }),
    },
  }),
};

const selectors = {
  selectOpen: (state) => getOr(false, 'open', state[name]),
  selectMessage: (state) => getOr('', 'message', state[name]),
  selectSeverity: (state) => getOr('info', 'severity', state[name]),
  selectPersistent: (state) => getOr(false, 'persistent', state[name]),
};

export default {
  actions: {
    ...actions,
  },
  selectors,
  reducer,
  name,
};
